import {utilHelper} from "../../_helpers";

const relativeUrl = 'api/translateStatus'

export const translateStatusService = {
    getOptions,
};

//getOptions
function getOptions() {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/getOptions`, 'POST', { showAlert:false })
}